import React from 'react'
import SubLink from '../../Route/SubLink';
import {MachineMappingData} from '../../Route/SubLinkJSON';



function MachineMapping() {
  return (
  <React.Fragment>
      <SubLink sublinks={MachineMappingData} />
      </React.Fragment>
  )
}

export default MachineMapping